import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c1275a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "strategy-info"
}
const _hoisted_2 = { class: "info-header" }
const _hoisted_3 = { class: "detail-title" }
const _hoisted_4 = {
  key: 0,
  class: "tag-list"
}
const _hoisted_5 = { class: "info-body" }
const _hoisted_6 = {
  key: 0,
  class: "detail-desc"
}
const _hoisted_7 = {
  key: 1,
  class: "strategy-info empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.strategy)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.strategy.name), 1),
          (_ctx.strategy.tags && _ctx.strategy.tags.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.strategy.tags, (tag) => {
                  return (_openBlock(), _createElementBlock("span", {
                    class: "tag-item",
                    key: tag
                  }, _toDisplayString(tag), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_ctx.strategy.profile)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.strategy.profile), 1))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createElementVNode("span", null, _toDisplayString(_ctx.tran('请选择左侧策略查看详情')), 1)
      ]))
}